// Import components to register custom elements
import { Modal } from "../../web-components/native_components/modal";
import { Button } from "../../web-components/native_components/button";

// Ensure components are registered
void Modal;
void Button;

interface ModalComponent extends HTMLElement {
  open(): void;
  close(): void;
  alignment?: "left" | "center";
  "backdrop-style"?: "blur" | "solid" | "transparent";
  "close-on-backdrop-click"?: string;
  "show-close-button"?: string;
  anchor?: "top" | "middle" | "bottom";
  "anchor-bottom-on-mobile"?: string;
}

declare global {
  interface Window {
    gtag: (
      type: string,
      eventName: string,
      params: Record<string, string>,
    ) => void;
  }
}

const gaTrack = (eventName: string, params?: Record<string, string>) => {
  if (typeof window.gtag !== "undefined" && window.gtag !== null) {
    window.gtag("event", eventName, params || {});
  }
};

const setCookie = () => {
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + 3);
  document.cookie = `idme-extension-modal-dismissed=true; path=/; expires=${expiryDate.toUTCString()}`;
};

export function initPage() {
  const modal = document.querySelector<ModalComponent>(
    "modal-component#browser-extension-modal",
  );
  if (!modal) return;

  const primaryButton = modal.querySelector(
    "button-component[slot='primary-action']",
  );
  if (primaryButton) {
    primaryButton.addEventListener(
      "click",
      () => {
        gaTrack("extension_modal_click", {
          label: "Add to Chrome",
        });
        modal.close();
      },
      { once: true },
    );
  }

  modal.addEventListener("modal-open", () => {
    gaTrack("extension_modal_impression");
  });

  modal.addEventListener("modal-close", () => {
    setCookie();
  });

  modal.addEventListener("modal-backdrop-click", () => {
    setCookie();
  });

  modal.addEventListener("modal-cancel", () => {
    setCookie();
  });

  modal.open();
}
